<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12">
        <v-banner icon="mdi-clipboard-file-outline"
          >Request Invoice Copy</v-banner
        >
      </v-col>

      <v-col cols="12" md="12" sm="12">
        <v-row justify="center" align="start">
          <v-col cols="12" md="3" sm="12">
            <v-form v-model="valid" @submit.prevent="loadExistingOrders">
              <v-text-field
                dense
                outlined
                v-model="numberOfDays"
                label=" No. of days"
                class="shrink"
                :rules="[required('No. of Days'), isValidNumber]"
                @focus="$event.target.select()"
                color="blue darken-2"
                type="number"
                :hint="`Load orders from the past ${this.numberOfDays} days`"
                persistent-hint
              ></v-text-field>
            </v-form>
          </v-col>

          <v-col cols="12" md="9" sm="12">
            <v-btn
              block
              large
              :disabled="!valid"
              @click.stop="loadExistingOrders"
              color="blue darken-2"
              outlined
              :loading="loadingInvoices"
            >
              <v-icon class="mr-2">refresh</v-icon>Load Invoices
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="invoices"
          :loading="loadingInvoices"
          class="elevation-0"
        >
          <template v-slot:item.ticketStatus="{ item }">
            <span class="font-weight-medium">{{
              getOrderStatus(item.status)
            }}</span>
          </template>

          <template v-slot:item.invoiceNo="{ item }">
            <span class="font-weight-medium">{{ item.invoice_no }}</span>
          </template>
          <template v-slot:item.deliveryDate="{ item }">
            <span class="font-weight-medium">{{ getDeliveryDate(item) }}</span>
          </template>
          <template v-slot:item.invoiceTotal="{ item }">
            <span class="font-weight-medium"
              >£ {{ parseFloat(item.net_total).toFixed(2) }}</span
            >
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="blue darken-2"
                  v-on="on"
                  @click.stop="sendInvoice(item.invoice_no)"
                >
                  <v-icon>send</v-icon>
                </v-btn>
              </template>
              <span>Send Invoice</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "CopyInvoice",
  data: () => {
    return {
      headers: [
        { text: "Status", value: "ticketStatus", sortable: false },
        { text: "Invoice No", value: "invoiceNo", sortable: false },
        { text: "Delivery Date", value: "deliveryDate", sortable: false },
        { text: "Total", value: "invoiceTotal", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isValidNumber: (v) => {
        return (
          /^([1-9]|[1-8][0-9]|9[0-9]|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$/.test(
            v
          ) || "Number must be valid"
        );
      },
      valid: false,
      numberOfDays: 90,
      invoices: [],
      loadingInvoices: false,
    };
  },
  computed: {
    ...mapGetters([
      "retrieveAllOrdersTickets",
      "retrieveAllOrders",
      "retrieveUser",
    ]),
  },
  methods: {
    ...mapActions(["fetchExistingOrders", "requestCopyInvoice", "setSnackbar"]),

    async loadExistingOrders() {
      this.loadingInvoices = true;
      this.invoices = [];

      let response = await this.fetchExistingOrders({
        daysPast: this.numberOfDays,
      });

      console.log(response);

      if (response) {
        let invoicedTickets = [];

        this.$store.getters.retrieveAllOrdersTickets.forEach((ticket) => {
          if (parseInt(ticket.status) >= 4) {
            invoicedTickets.push(ticket);
          }
        });

        this.invoices = invoicedTickets;
      } else {
        console.log("error fetchig orders");
      }

      this.loadingInvoices = false;
    },

    getDeliveryDate(item) {
      let deliveryDate = this.retrieveAllOrders.find(
        (order) => order.td_id == item.tdd_id
      ).transaction_date;
      return moment(deliveryDate).format("dddd, MMMM Do YYYY");
    },

    getOrderStatus(statusCode) {
      if (statusCode == 1) {
        return "Order Entered";
      } else if (statusCode == 2) {
        return "Order Picked";
      } else if (statusCode == 3) {
        return "Order Dispatched";
      } else if (statusCode == 4) {
        return "Order Invoiced";
      }
    },
    sendInvoice(invoiceNo) {
      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey },
        { ticketNum: invoiceNo }
      );
      this.requestCopyInvoice(rec)
        .then((response) => {
          if (response.success == true) {
            this.setSnackbar({
              text: "An Email of the Order Invoice has been sent to you",
            });
          } else {
            this.setSnackbar({ color: "error", text: response.message });
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },
  },

  activated() {
    this.loadExistingOrders();
  },
};
</script>
<style scoped>
</style>